
import React from 'react';

export default function StepsSection() {
  const steps = [
    {
      number: '01',
      title: 'Self-Check',
      subtitle: 'Quick Health Assessment',
      description: 'Answer simple questions about your health, lifestyle, and symptoms. Takes less than 90 seconds.',
      icon: 'ri-questionnaire-line',
      features: ['Medical history', 'Lifestyle factors', 'Current symptoms', 'Activity levels']
    },
    {
      number: '02',
      title: 'OxyScore™',
      subtitle: 'AI-Powered Analysis',
      description: 'Our advanced AI analyzes your responses and calculates your personalized oxygen deficiency risk score.',
      icon: 'ri-brain-line',
      features: ['Risk assessment', 'Pattern recognition', 'Instant results', 'Scientific accuracy']
    },
    {
      number: '03',
      title: 'Personalized Plan',
      subtitle: 'Tailored Recommendations',
      description: 'Receive customized guidance, lifestyle recommendations, and next steps based on your OxyScore™.',
      icon: 'ri-road-map-line',
      features: ['Custom recommendations', 'Action plans', 'Progress tracking', 'Expert guidance']
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#111111] mb-6">
            How <span className="text-[#12B6B6]">OxyAI™</span> Works
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Three simple steps to understand your oxygen health and get personalized recommendations.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-20 left-full w-12 h-0.5 bg-gradient-to-r from-[#12B6B6] to-gray-200 transform -translate-x-6"></div>
              )}
              
              <div className="bg-[#FAFAFA] rounded-3xl p-8 h-full">
                <div className="flex items-center space-x-4 mb-6">
                  <div className="w-16 h-16 bg-[#12B6B6] rounded-2xl flex items-center justify-center">
                    <i className={`${step.icon} text-2xl text-white`}></i>
                  </div>
                  <div>
                    <div className="text-sm font-mono text-[#12B6B6] mb-1">{step.number}</div>
                    <h3 className="text-xl font-bold text-[#111111]">{step.title}</h3>
                    <p className="text-sm text-gray-600">{step.subtitle}</p>
                  </div>
                </div>

                <p className="text-gray-700 mb-6 leading-relaxed">
                  {step.description}
                </p>

                <div className="space-y-2">
                  {step.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center space-x-2">
                      <i className="ri-check-line text-[#12B6B6] text-sm"></i>
                      <span className="text-sm text-gray-600">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
